import {
  StyledDurationWrapper,
  StyledFlexSuccessContainer,
  StyledGrowContainer,
} from "../index.styled";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { Fonts } from "@lib/constants/AppEnums";

export type GrowTextProps = {
  hidePercent?: boolean;
  percentageChange: number;
  duration: string;
};

type Props = { data: GrowTextProps; loading: boolean };

export default function GrowText({ data, loading }: Props) {
  if (loading) return null;
  return (
    <StyledGrowContainer>
      <StyledFlexSuccessContainer>
        {!data?.hidePercent && (
          <span style={{ marginRight: 4 }}>
            {data.percentageChange > 0 ? <FaArrowUp /> : <FaArrowDown />}
          </span>
        )}

        <span
          style={{
            marginLeft: 1,
            fontSize: 14,
            fontWeight: Fonts.BOLD,
            color: data.percentageChange > 0 ? "#11C15B" : "#F04F47",
          }}
        >
          {data.percentageChange > 0 ? "+" : ""}
          {data.percentageChange}%
        </span>
      </StyledFlexSuccessContainer>
      <StyledDurationWrapper>
        <span>{data.duration}</span>
      </StyledDurationWrapper>
    </StyledGrowContainer>
  );
}
